
<!-- 
	使用说明:
	<div style="display: flex; flex-direction: column;">
		<QLBtn text="霹雳陈" />
		<QLBtn :text="'临时通知'" :images="['icon_top_nav_msg_0', 'icon_top_nav_msg_1']" />
		<QLBtn :images="['icon_top_nav_msg_0', 'icon_top_nav_msg_1']" />
		<QLBtn style="margin-top: 30px;" :dropdownBoxText="'修改密码'" :text="'霹雳陈'" :images="['icon_top_nav_msg_0', 'icon_top_nav_msg_1']" />
	</div>
 -->

 <template>
	<div 
	:class="[btnState == 0 ? 'defaultStyle' : btnState == 1 ? 'hoverStyle' : 'downStyle', 'qlBtn']"
	style="display: flex; justify-content: center; align-items: center; position: relative; cursor: pointer;" 
	:style="{ paddingLeft: paddingLeft, paddingRight: paddingRight, paddingTop: paddingTop, paddingBottom: paddingBottom, width: width, height: height }"
	@mouseover="btnHover"
	@mouseout="btnRemoveHover"
	@mousedown="btnMousedown"
	@mouseup="btnMouseup"
	onselectstart="return false"
	>
		<img v-if="images && images.length == 2 && !imgIsRight" style="width: 16px; height: 18px; margin-right: 2px;" alt="" :src="require('../../assets/' + (btnState == 0 ? images[0] : images[1]) + '.png')" onselectstart="return false" :style="{width: imageWidth, height: imageHeight, marginRight: imageMarginRight ? imageMarginRight : '2px'}" />
		<div v-if="text" style="font-size: 14px; font-family: PingFangSC, PingFang SC; color: #5E6779; line-height: 20px;" :style="{color: btnState != 0 ? '#4A7CE8' : '#5E6779', fontWeight: fontWeight}">{{ text || '' }}</div>
		<img v-if="images && images.length == 2 && imgIsRight" style="width: 16px; height: 18px; margin-left: 2px;" alt="" :src="require('../../assets/' + (btnState == 0 ? images[0] : images[1]) + '.png')" onselectstart="return false" :style="{width: imageWidth, height: imageHeight}" />
		<div v-if="dropdownBoxText" class="dropdownBox" style="position: absolute; top: 40px;">
			<div style="display: flex; flex-direction: column; align-items: center;">
				<img style="width: 38px; height: 12px;" alt="" src="../../assets/icon_common_special_triangle_1.png">
				<div 
				style="background: #FFFFFF; border-radius: 8px;"
				@mouseover="dropdownBoxHover"
				@mouseout="dropdownBoxRemoveHover"
				@click.stop="dropdownBoxClick"
				>
					<div 
					style="height: 34px; font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #4A7CE8; line-height: 24px; display: flex; align-items: center; white-space: nowrap; margin: 5px 0px; padding: 0px 15px;"
					:style="{background: dropdownBoxState == 0 ? '#FFFFFF' : 'rgba(74, 124, 232, 0.05)', color: dropdownBoxState == 0 ? 'rgba(94, 103, 121, 1)' : 'rgba(74, 124, 232, 1)'}"
					>{{ dropdownBoxText || '' }}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	props: {
		// btn - 内边距
		paddingLeft: {
			type: String,
			default: '10px'
		},
		paddingRight: {
			type: String,
			default: '10px'
		},
		paddingTop: {
			type: String,
			default: '10px'
		},
		paddingBottom: {
			type: String,
			default: '10px'
		},
		width: {
			type: String,
			default: 'unset'
		},
		height: {
			type: String,
			default: 'unset'
		},
		// 文本
		text: {
			type: String,
			default: null
		},
		// 图片
		images: {
			type: Array,
			default: null
		},
		imageWidth: {
			type: String,
			default: '16px'
		},
		imageHeight: {
			type: String,
			default: '18px'
		},
		imageMarginRight: {
			type: String,
			default: null
		},
		// 是否显示下拉框
		isShowDropdownBox: {
			type: Boolean,
			default: false
		},
		dropdownBoxText: {
			type: String,
			default: null
		},
		imgIsRight: {
			type: Boolean,
			default: false
		},
		fontWeight: {
			type: String,
			default: '400'
		}
	},
	components: {
	},
	data() {
		return {
			btnState: 0, // 0-未hover 1-hover 2-按下
			dropdownBoxState: 0, // 0-未hover 1-hover
		};
	},
	created() { },
	mounted() { },
	methods: {
		btnHover() {
			this.btnState = 1;
		},
		btnRemoveHover() {
			this.btnState = 0;
		},
		btnMousedown() { // 鼠标按下
			this.btnState = 2;
		},
		btnMouseup() { // 鼠标松开
			this.btnState = 1;
			this.$emit('btnClick');
		},
		dropdownBoxHover() {
			this.btnState = 1
			this.dropdownBoxState = 1;
		},
		dropdownBoxRemoveHover() {
			this.dropdownBoxState = 0;
		},
		dropdownBoxClick() {
			this.$emit('dropdownBoxClick');
		}
	},
	beforeDestroy() { },
};
</script>
<style lang="scss" scoped>
.defaultStyle {
	background: #ECF0F3; 
	box-shadow: 3px 3px 6px 0px rgba(209,217,230,0.8), -3px -3px 6px 0px rgba(255,255,255,0.8); 
	border-radius: 20px;
}
.hoverStyle {
	background: #DFE8FC;
	box-shadow: 3px 3px 6px 0px rgba(209,217,230,0.8), -3px -3px 6px 0px rgba(255,255,255,0.8);
	border-radius: 20px;
}
.downStyle {
	background: #DFE8FC;
	box-shadow: inset 3px 3px 6px 0px rgba(199,207,221,0.9), inset -3px -3px 6px 0px rgba(255,255,255,0.9);
	border-radius: 20px;
}
.dropdownBox {
	display: none;
}
.qlBtn:hover .dropdownBox{
	display: block;
}

</style>
  